import { render } from "./TeamPage.vue?vue&type=template&id=d75b3fec&scoped=true"
import script from "./TeamPage.vue?vue&type=script&lang=js"
export * from "./TeamPage.vue?vue&type=script&lang=js"

import "./TeamPage.vue?vue&type=style&index=0&id=d75b3fec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d75b3fec"]])

export default __exports__